import { COGNISM_CONTACTS, useVariableValue } from "lib/featureFlags";
import { useCurrentUser } from "lib/hooks/api/users/useCurrentUser";

/**
 * Whether the user gets the unified contacts experience: source-aware contact search in place of
 * the legacy Oscar table, and recommended contacts on leads.
 *
 * Two independent switches, either of which turns it on:
 * - `unifiedContactsEnabled`, the per-company toggle in the admin panel. This is how a whole
 *   company is granted the experience once their T&Cs allow it.
 * - the `cognism-contacts` flag, targeted at individual users, so Stotlers can demo the new
 *   experience on accounts that don't have the toggle.
 *
 * Whether a user may see contact data at all is a separate axis, and stays the CONTACTS data type
 * (see `useSubscription`). A company can have this experience and still be paywalled out of it.
 */
export function useUnifiedContacts(): boolean {
  const { data: currentUser } = useCurrentUser();
  // Coerced: the e2e flag mock returns undefined rather than the declared boolean.
  const flagEnabled = useVariableValue(COGNISM_CONTACTS, false) === true;

  return currentUser?.company.unifiedContactsEnabled === true || flagEnabled;
}
